<div class="card panel-flat-color primary-panel flex-panel">
    <div class="panel-flat-header ws-flex-container-horizontal">
        <h3 class="ws-truncate ws-flex-auto">Return Settings Override</h3>
        <div class="ws-flex-none header-button-container">
            @if (!editMode && canEdit) {
                <button
                    title="Edit"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    [disabled]="!canEnterEditMode"
                    (click)="edit()">
                    <i class="fa fa-pencil fa-align"></i>
                </button>
            }
            @if (editMode) {
                <button title="Save"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        [disabled]="!hasChanges"
                        (click)="save()">
                    <i class="fa fa-save fa-align"></i>
                </button>
            }
            @if (editMode) {
                <button title="Cancel"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="cancel()">
                    <i class="fa fa-times fa-align"></i>
                </button>
            }
        </div>
    </div>
    <div class="panel-flat-body">
        @if (returnId) {
            <return-settings [entityId]="returnId" [entityType]="ReturnSettingsEntityTypeEnum.Return"
                             (onInitialized)="onReturnSettingsInitialized($event)"
                             (changed)="onReturnSettingsChanged($event)"></return-settings>
        }
    </div>
</div>
